"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.knownIcon = void 0;
// Copyright 2017-2023 @polkadot/networks authors & contributors
// SPDX-License-Identifier: Apache-2.0

// these are icon overrides
const knownIcon = {
  centrifuge: 'polkadot',
  kusama: 'polkadot',
  polkadot: 'polkadot',
  sora: 'polkadot',
  statemine: 'polkadot',
  statemint: 'polkadot',
  westmint: 'polkadot'
};
exports.knownIcon = knownIcon;